import React, { lazy } from 'react';

const TarotWelcome      = lazy(() => import('@/pages/client/Tarot/Welcome/index.js'));
const TarotQuestion     = lazy(() => import('@/pages/client/Tarot/Question/index.js'));
const TarotPickCard     = lazy(() => import('@/pages/client/Tarot/PickCard/index.js'));
const TarotCardHistory  = lazy(() => import('@/pages/client/Tarot/CardHistory/index.js'));
const TarotAnalysis     = lazy(() => import('@/pages/client/Tarot/Analysis/index.js'));

const tarotRoutes = [
  { path: '/client/tarot/welcome/:deckId', component: <TarotWelcome />,      needInterceptor: true },
  { path: '/client/tarot/question',        component: <TarotQuestion />,     needInterceptor: true },
  { path: '/client/tarot/pick-card',       component: <TarotPickCard />,     needInterceptor: true },
  { path: '/client/tarot/card-history',    component: <TarotCardHistory />,  needInterceptor: true },
  { path: '/client/tarot/analysis',        component: <TarotAnalysis />,     needInterceptor: true },
];

export default tarotRoutes;
